import { Autocomplete, Checkbox, FormControl, FormHelperText, TextField } from "@mui/material"

export type CustomAutoCompleteGroupByProps<T> = {
  label: string
  options: T[]
  value: T | T[] | null
  onChange: (value: T | T[] | null) => void
  //
  getOptionLabel: (option: T) => string
  isOptionEqualToValue: (option: T, value: T) => boolean
  //
  multiple?: boolean
  showCheckboxes?: boolean
  groupBy?: (option: T) => string
  renderGroup?: (params: {
    key: string
    group: string
    children: React.ReactNode
  }) => React.ReactNode
  placeholder?: string
  disabled?: boolean
  error?: boolean
  helperText?: React.ReactNode
  size?: 'small' | 'medium'
  icon?: React.ReactNode
  checkedIcon?: React.ReactNode

}
export default function CustomAutoCompleteGroupBy<T>({
  label,
  options,
  value,
  onChange,
  getOptionLabel,
  isOptionEqualToValue,
  multiple = false,
  groupBy,
  //renderGroup,
  placeholder,
  disabled = false,
  error = false,
  helperText,
  size = 'medium',
  icon,
  checkedIcon,
  showCheckboxes = false,
}: CustomAutoCompleteGroupByProps<T>) {

  return (
    <FormControl fullWidth error={error} >
      <Autocomplete
        options={options}
        multiple={multiple}
        disableCloseOnSelect={multiple}
        value={value as any}
        groupBy={groupBy}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isOptionEqualToValue}
        onChange={(_event, newValue) => onChange(newValue as any)}
        disabled={disabled}
        renderOption={(props, options, { selected }) => (
          <li {...props}>
            {(multiple || showCheckboxes) && (
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
            )}
            {getOptionLabel(options)}
          </li>
        )}
        renderInput={(params) => (
          <TextField
          {...params}
          label={label}
          placeholder={ placeholder}
          size={size}
          />
        )}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}